
import configInfo from "../../configInfo.js"

let urlPrefix = configInfo.Laurels_URL;

const serviceModule = {
  getWechatShareInfo: () => {
      return {
          url: urlPrefix + '/wechat/sharewithfriend',
          method: 'post'
      }
  },
  getImgAsset: (assetId) => {
    return {
      url: urlPrefix + '/resource/img?img=' + assetId,
      method: 'get'
    }
  },
  getLeagueBasic: (leagueId) => {
    return {
      url: urlPrefix + '/leagueinfo/basic/' + leagueId,
      method: 'get'
    }
  },
  getLeagueMatches: (leagueId, offset, length, finish) => {
    return {
      url: urlPrefix + '/leagueinfo/matches/' + leagueId + '?offset=' + offset + '&length=' + length + '&finish=' + finish,
      method: 'get'
    }
  },
  getRoundMatches:(leagueId, roundId, offset, length) => {
    return {
      url: urlPrefix + '/leagueinfo/matches/' + leagueId + '/'+roundId+'?offset=' + offset + '&length=' + length,
      method: 'get'
    }
  },
  getLeagueShooters: (leagueId, offset, length) => {
    return {
      url: urlPrefix + '/leagueinfo/shooters/' + leagueId + '?offset=' + offset + '&length=' + length,
      method: 'get'
    }
  },
  getHotLeagues: () => {
    return {
      url: urlPrefix + '/api/v1/publicIndex/listHotLeague',
      method: 'get'
    }
  },
  getLeagueMatchesAssets: (leagueId, offset, length) => {
    return {
      url: urlPrefix + '/leagueinfo/matches_assets/' + leagueId + '?offset=' + offset + '&length=' + length,
      method: 'get'
    }
  },
  getLeagueByOrgCodeAndName: (orgCode) => {
    return {
      url: urlPrefix + '/api/v1/league/getLeagueByOrgCodeAndName/' + orgCode,
      method: 'get'
    }
  },
  getAllHotRegion: () => {
    return {
      url: urlPrefix + '/api/v1/hotRegion/getAllHotRegion',
      method: 'get'
    }
  },
  getLeagueTeams: (leagueId) => {
    return {
      url: urlPrefix + '/api/v1/leagueTeam/' + leagueId,
      method: 'get'
    }
  },
  getIndex: (regionCode) => {
    return {
      url: urlPrefix + '/api/v1/index/' + regionCode,
      method: 'get'
    }
  },
  getIndexLeague: (leagueId) => {
    return {
      url: urlPrefix + '/api/v1/index/league/' + leagueId,
      method: 'get'
    }
  },
  getHotAreaLeagueCount: (regionCode) => {
    return {
      url: urlPrefix + '/api/v1/publicIndex/getHotAreaLeagueCount/' + regionCode,
      method: 'get'
    }
  },
  getLeagueCountIndex: (regionCode) => {
    return {
      url: urlPrefix + '/api/v1/publicIndex/getLeagueCountIndex/' + regionCode,
      method: 'get'
    }
  },
  geoLatLngToCityInfo: () => {
    return {
      url: urlPrefix + '/baidu/geoLatLngToCityInfo',
      method: 'post'
    }
  },
    getLeagueTable: (leagueId) => {
    return {
      url: urlPrefix + '/leagueinfo/' + leagueId + '/table',
      method: 'get'
    }
  },
    getImgAsset: (assetId) => {
        return {
            url: urlPrefix +'/resource/img?img='+assetId,
            method: 'get'
        }
    },
    getLeagueBasic: (leagueId) => {
        return {
            url: urlPrefix +'/leagueinfo/basic/'+leagueId,
            method: 'get'
        }
    },
    getLeagueMatches: (leagueId,offset,length, finish) => {
        return {
            url: urlPrefix +'/leagueinfo/matches/'+leagueId+'?offset='+offset+'&length='+length+'&finish='+finish,
            method: 'get'
        }
    },
    getLeagueShooters: (leagueId,offset,length) => {
        return {
            url: urlPrefix +'/leagueinfo/shooters/'+leagueId+'?offset='+offset+'&length='+length,
            method: 'get'
        }
    },
    getLeagueMatchesAssets: (leagueId,offset,length) => {
        return {
            url: urlPrefix +'/leagueinfo/matches_assets/'+leagueId+'?offset='+offset+'&length='+length,
            method: 'get'
        }
    },
    getLeagueByOrgCodeAndName:(orgCode) => {
    	return {
    		url: urlPrefix+'/api/v1/league/getLeagueByOrgCodeAndName/'+orgCode,
    		method: 'get'
    	}
    },
    getAllHotRegion:() => {
        return {
            url: urlPrefix+'/api/v1/hotRegion/getAllHotRegion',
            method: 'get'
        }
    },
    getLeagueTeams: (leagueId) => {
      return {
        url: urlPrefix +'/api/v1/leagueTeam/'+leagueId,
        method: 'get'
      }
    },
    getIndex: (regionCode) => {
      return {
        url: urlPrefix +'/api/v1/index/' + regionCode,
        method: 'get'
      }
    },
    getLeagueTable: (leagueId) => {
      return {
        url: urlPrefix +'/leagueinfo/' +leagueId + '/table',
        method: 'get'
      }
    },
    getLeagueData: (leagueId) => {
      return {
        url: urlPrefix +'/leagueinfo/data/'+leagueId,
        method: 'get'
      }
    },
    getImgAssetById: (assetId) => {
        return {
            url: urlPrefix +'/hagkFile/show?assetId='+assetId,
            method: 'get'
        }
    },
    getMatchInfoById: (matchId) => {
      return {
        url: urlPrefix+'/match/getMatchInfoById/'+matchId,
        method: 'get'
      }
    },
    getRosterMatchInfo: (matchId, homeTeamId, visitTeamId) => {
      return {
        url: urlPrefix+'/match/getRosterMatchInfo/'+matchId+'/'+homeTeamId+'/'+visitTeamId,
        method: 'get'
      }
    },
    getLineUpByMatchIdAndTeamId: (matchId, teamId) => {
      return {
        url: urlPrefix+'/match/getLineUpByMatchIdAndTeamId/'+matchId+'/'+teamId,
        method: 'get'
      }
    },
    getSubstitutionByMatchIdAndTeamId: (matchId, teamId) => {
      return {
        url: urlPrefix+'/match/getSubstitutionByMatchIdAndTeamId/'+matchId+'/'+teamId,
        method: 'get'
      }
    },
    getMatchAssetsByMatchId: (matchId, type) =>{
      return{
        url: urlPrefix+'/match/getMatchAssetByMatchId/'+ matchId + '?type=' + type,
        method:'get'
      }
    },
    getMatchList: (orgCode, leagueId, offset, length) =>{
      if(leagueId) {
        return{
          url: urlPrefix+'/api/v1/match/list/'+orgCode+'?leagueId='+ leagueId + '&offset='+offset+'&length='+length,
          method:'get'
        }
      } else {
        return{
          url: urlPrefix+'/api/v1/match/list/'+orgCode+'?offset='+offset+'&length='+length,
          method:'get'
        }
      }
    },
    getLeagueList: (orgCode) =>{
      return{
        url: urlPrefix+'/api/v1/league/list/' + orgCode,
        method:'get'
      }
    }
}

const ApiSetting = {...serviceModule }

export default ApiSetting



// WEBPACK FOOTER //
// ./src/js/common/api.js